<template>
  <div></div>
</template>

<script>
import mixin from '@/utils/mixin.js';

export default {
  name: 'NotFound',
  mixins: [ mixin ],

  created() {
    this.sendBeacon('Page Not Found', 'Opened', {path: this.$route.params.path});
    this.$router.replace({name: 'Dashboard'});
  }
}
</script>
